import {Checkbox, Paper, Stack} from '@mantine/core';
import React from 'react';

import {handleSelectableCardKeyDown} from './selectableCardKeyboard';

interface SelectableCheckboxCardProps {
  cardClassName: string;
  checked: boolean;
  label: string;
  onToggle: () => void;
}

// TODO(nweeden): Merge with SelectableRadioCard into a single SelectableCardAroundInput.
export default function SelectableCheckboxCard({
  cardClassName,
  checked,
  label,
  onToggle,
}: SelectableCheckboxCardProps): JSX.Element {
  return (
    <Paper
      withBorder={true}
      p="sm"
      role="button"
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={(event) => {
        handleSelectableCardKeyDown(event, onToggle);
      }}
      className={cardClassName}
    >
      <Stack spacing="sm">
        {/* Stop clicks anywhere inside the checkbox (its box or its label) from bubbling to the
            card, so those clicks toggle exactly once (via onChange) rather than also firing the
            card's onClick. wrapperProps targets the element wrapping both the input and the label;
            a handler on the checkbox itself only covers the box, not the label. */}
        <Checkbox
          checked={checked}
          label={label}
          size="md"
          onChange={onToggle}
          wrapperProps={{
            onClick: (event: React.MouseEvent) => {
              event.stopPropagation();
            },
          }}
        />
      </Stack>
    </Paper>
  );
}
